import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSearchParams } from 'react-router-dom';
import { Formik, useFormikContext } from 'formik';
import SearchBox from '../../Components/SearchBox';

const FormObserver = ({ onChange }) => {
    const { values } = useFormikContext();
    useEffect(() => {
        onChange(values);
    }, [values, onChange]);
    return null;
};
import PopularLessonsTable from './components/PopularLessonsTable';
import PopularQuizTable from './components/PopularQuizTable';
import ChatMessageChart from './components/ChatMessageChart';
import PubertyCountsChart from './components/PubertyCountsChart';
import HeardProductsChart from './components/HeardProductsChart';
import SymptomExperienceChart from './components/SymptomExperienceChart';

const tabs = [
    { id: 'popular-lessons', label: 'Popular Lessons' },
    { id: 'popular-quiz', label: 'Popular Quiz' },
    { id: 'chat-messages', label: 'Chat Message Overview' },
    { id: 'puberty-counts', label: 'Puberty Counts Overview' },
    { id: 'heard-products', label: 'Heard Products Overview' },
    { id: 'symptom-experience', label: 'Symptom Experience Overview' },
];

const Analytics = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const activeTab = searchParams.get('tab') || 'popular-lessons';
    const [searchQuery, setSearchQuery] = React.useState('');
    const [clearSearchValue, setClearSearch] = React.useState(false);

    const handleTabChange = (tabId) => {
        setSearchParams({ tab: tabId });
        setSearchQuery(''); // Clear search query on tab change
        setClearSearch(true);

        setTimeout(() => {
            setClearSearch(false);
        }, 1000);
    };

    useEffect(() => {
        // If no tab is in URL, set default to popular-lessons without breaking history
        if (!searchParams.get('tab')) {
            setSearchParams({ tab: 'popular-lessons' }, { replace: true });
        }
    }, [searchParams, setSearchParams]);

    const renderTabContent = () => {
        switch (activeTab) {
            case 'popular-lessons':
                return <PopularLessonsTable searchQuery={searchQuery} />;
            case 'popular-quiz':
                return <PopularQuizTable searchQuery={searchQuery} />;
            case 'chat-messages':
                return <ChatMessageChart />;
            case 'puberty-counts':
                return <PubertyCountsChart />;
            case 'heard-products':
                return <HeardProductsChart />;
            case 'symptom-experience':
                return <SymptomExperienceChart />;
            default:
                return <PopularLessonsTable searchQuery={searchQuery} />;
        }
    };

    return (
        <React.Fragment>
            <Helmet>
                <title>Ove | Analytics</title>
            </Helmet>
            <div className="page-wrapper subscription-container">
                <div className="content container-fluid">
                    <div className="admin-wrapper subscription-table analytics-wrapper">
                        <div className="page-header mb-3">
                            <div className="w-100 d-flex justify-content-between align-items-center flex-wrap gap-2">
                                <h1 className="page-title mb-0">Analytics</h1>
                                {(activeTab === 'popular-lessons' || activeTab === 'popular-quiz') && (
                                    <div className="d-flex align-items-center gap-2">
                                        <div style={{ width: "250px" }}>
                                            <Formik
                                                initialValues={{ search: searchQuery }}
                                                enableReinitialize
                                            >
                                                {() => (
                                                    <>
                                                        <FormObserver onChange={(vals) => setSearchQuery(vals.search || '')} />
                                                        <SearchBox refetch={() => { }} clearSearch={clearSearchValue} />
                                                    </>
                                                )}
                                            </Formik>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="subscription-tabs mb-3 d-flex flex-wrap gap-2">
                            {tabs.map((tab) => (
                                <button
                                    type="button"
                                    key={tab.id}
                                    className={`subscription-tab-btn ${activeTab === tab.id ? 'active' : ''}`}
                                    onClick={() => handleTabChange(tab.id)}
                                >
                                    {tab.label}
                                </button>
                            ))}
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <div>
                                    <div className="mt-3">
                                        {renderTabContent()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Analytics;
